module.exports = __webpack_public_path__ + "img/7.b018f1d0.png";